import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import {
  FeeRequestSI,
  FeeResponseSI,
  PaymentScheduleRequestSI,
  PaymentScheduleResponseSI,
  PeriodicPaymentRequestSI,
} from '@views/interfaces/services/fee.interface';

@Injectable({
  providedIn: 'root',
})
export class FeesService {
  constructor(private _http: HttpClient) {}

  async getFee(idPolicyData: string): Promise<FeeResponseSI> {
    const result = await firstValueFrom<ResponseCommonSI<FeeResponseSI>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.PAYMENT_SCHEDULE}/${idPolicyData}`)
    );
    return result.payload;
  }
  async addFee(body: FeeRequestSI): Promise<FeeResponseSI> {
    const result = await firstValueFrom<ResponseCommonSI<FeeResponseSI>>(
      this._http.post(`${BASE_URL}${ENDPOINTS.PAYMENT_SCHEDULE}`, body)
    );
    return result.payload;
  }

  async addPeriodicPayment(
    body: PeriodicPaymentRequestSI
  ): Promise<FeeResponseSI[]> {
    const result = await firstValueFrom<ResponseCommonSI<FeeResponseSI[]>>(
      this._http.post(`${BASE_URL}${ENDPOINTS.PERIODIC_PAYMENT}`, body)
    );
    return result.payload;
  }

  async delete(idPaymentSchedule: string): Promise<void> {
    await firstValueFrom(
      this._http.delete(
        `${BASE_URL}${ENDPOINTS.DELETE_PAYMNET_SCHEDULE.replace(':id', idPaymentSchedule)}`
      )
    );
  }

  async deleteAll(idPolicyData: string): Promise<void> {
    await firstValueFrom(
      this._http.delete(
        `${BASE_URL}${ENDPOINTS.DELETE_ALL_PAYMNET_SCHEDULE.replace(':idPolicyData', idPolicyData)}`
      )
    );
  }

  async patch(idPaymentSchedule: string, request: any): Promise<void> {
    await firstValueFrom(
      this._http.patch(
        `${BASE_URL}${ENDPOINTS.POLICY_PAYMENT_SCHEDULE_PATCH.replace(':idPaymentSchedule', idPaymentSchedule)}`,
        request
      )
    )
  }

  async validate(
    body: PaymentScheduleRequestSI
  ): Promise<PaymentScheduleResponseSI> {
    const result = await firstValueFrom<
      ResponseCommonSI<PaymentScheduleResponseSI>
    >(
      this._http.post(
        `${BASE_URL}${ENDPOINTS.PAYMENT_SCHEDULE_VALIDATION}`,
        body
      )
    );
    return {... result.payload, message: result.message};
  }
}
